import React, { useState } from 'react';
import { Link } from 'gatsby';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { FaShoppingBag as Bag } from 'react-icons/fa';
import { FaArrowCircleLeft as Arrow } from 'react-icons/fa'; 
import styled from 'styled-components';

const SingleProductImagesStyles = styled.div`

    .gatsby-image-wrapper {
        opacity: 0;
        animation: fade-in .3s ease-out forwards;
    }

    .single-product__thumbnails {
        display: grid;
        grid-template-columns: repeat(auto-fit, 50px);
        grid-gap: 1rem;
        justify-content: space-between;
        button {
            padding: 0;
            background: transparent;
            position: relative;
        }
    }

`;

const ThumbnailStyles = styled.button`

    &::before {
        content: '';
        display: block;
        position: absolute;
        z-index: 8;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: ${ props => props.isActive ? 'transparent' : 'rgba(255, 255, 255, .35)' };
    }

`;

const SingleProductDetailsStyles = styled.div `

    .single-product__return {
        a {
            color: var(--grey);
        }

        svg {
            color: var(--red);
            position: relative;
            top: 7px;
            margin-right: .75rem;
        }

        a:hover,
        svg:hover {
            color: #8F0002;
        }
    }

    h3 {
        margin-top: 2.5rem;
    }

    .single-product__size {
        
        h5 {
            font-family: HammersmithOne;
            font-size: 1.6rem;
            color: var(--grey);
        }

        span {
            font-size: 2.2rem;
        }
    }

    .single-product__checkout {
        display: inline-block;
        font-family: HammersmithOne, sans-serif;
        font-size: 1.6rem;
        color: var(--grey);
        cursor: pointer;
        margin-top: 1.5rem;
        
        &:hover {
            text-decoration: underline;
        }
    }

`;

export default function SingleProductItem({ singleProduct }) {

    const [activeImage, setActiveImage] = useState(getImage(singleProduct.images[0].asset));

    return <>
        <SingleProductImagesStyles>
            <GatsbyImage
                image={activeImage}
                alt={singleProduct.name} />
            {singleProduct.images.length > 1 ? (
                <div className="single-product__thumbnails">
                    {singleProduct.images.map((image) => (
                        <ThumbnailStyles key={image.asset._id} onClick={() => setActiveImage(getImage(image.asset))} isActive={activeImage === getImage(image.asset)} aria-label="image thumbnail">
                            <GatsbyImage image={getImage(image.asset)} alt={singleProduct.name} />
                        </ThumbnailStyles>
                    ))}
                </div>
            ) : (
                ''
            )}
        </SingleProductImagesStyles>
        <SingleProductDetailsStyles>
            <div className="single-product__return">
                <Link to={`/${singleProduct._type}s`}><Arrow /> {`return to the ${singleProduct._type}s page`}</Link>
            </div>
            <h3>{singleProduct.name}</h3>
            <p>{singleProduct.description}</p>
            <div className="single-product__price">
                <span>${singleProduct.price}</span>
            </div>
            {singleProduct.variants.length > 0 ? (
                <div className="single-product__size">
                    <h5>available sizes:</h5>
                    <span>{ singleProduct.variants[0].sizes.join(' , ') }</span>
                </div>
            ) : (
                ''
            ) }
            <div>
                <button className="snipcart-add-item"
                    data-item-id={singleProduct.id}
                    data-item-price={singleProduct.price}
                    data-item-url={`https://imjustbeastin.netlify.app/${singleProduct._type}/${singleProduct.slug.current}`}
                    data-item-description={singleProduct.description}
                    data-item-image={singleProduct.images[0].asset.url}
                    data-item-name={singleProduct.name}
                    data-item-custom1-name={singleProduct.variants.length ? 'Size' : null}
                    data-item-custom1-options={singleProduct.variants.length ? singleProduct.variants[0].sizes.join('|') : null}
                ><Bag /> add to cart</button>
            </div>
            <div className="single-product__checkout">
                <span className="snipcart-checkout">checkout now</span>
            </div>
        </SingleProductDetailsStyles>
    </>;
}